import { faCheck } from '@fortawesome/free-solid-svg-icons/faCheck';
import { faGear } from '@fortawesome/free-solid-svg-icons/faGear';
import { faUsersViewfinder } from '@fortawesome/free-solid-svg-icons/faUsersViewfinder';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { AtiraEmptyWithAction } from '../../../components/AtiraEmptyWithAction';
import { AtiraIcon } from '../../../components/AtiraIcon';
import { Flex } from '../../../components/Flex';
import { Text } from '../../../components/Text';
import { atiraLinkSliceSelectors } from '../../../redux/atira-link/atira-link.selector';
import { AtiraLinkActions } from '../../../redux/atira-link/atira-link.slice';
import { useAppDispatch, useAppSelector } from '../../../redux/store';
import { userSliceSelectors } from '../../../redux/user/user.selector';
import { DashboardWidget } from './DashboardWidget';

export const DashboardIndexWidget: React.FC = () => {
  const { t } = useTranslation();

  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const selectedAtiraLink = useAppSelector(
    atiraLinkSliceSelectors.selectSelectedAtiraLink,
  );
  const userId = useAppSelector(userSliceSelectors.selectLoggedInUserId)!;

  const isIndexed = selectedAtiraLink?.indexVisible;

  useEffect(() => {
    dispatch(AtiraLinkActions.getUserAtiraLinks({ userId }));
  }, [dispatch, userId]);

  return (
    <DashboardWidget
      title={t('dashboard.widget.index.title')}
      titleIcon={faUsersViewfinder}
      mainAction={{
        icon: faGear,
        title: t('dashboard.widget.index.action'),
        onClick: () =>
          navigate('/settings', { state: { targetedTab: 'link-index' } }),
      }}
      showActions={Boolean(isIndexed)}
    >
      {isIndexed ? (
        <Flex flexDirection="column" gap="m" alignItems="center" padding="m">
          <AtiraIcon icon={faCheck} size="2xl" color="main" />

          <Text fontWeight={'bold'} color="main" fontSize="l">
            {t('dashboard.widget.index.indexed')}
          </Text>
        </Flex>
      ) : (
        <Flex padding="xl" justifyContent="center" height={'150px'}>
          <AtiraEmptyWithAction
            buttonTitle={t('dashboard.widget.index.empty.action')}
            description={t('dashboard.widget.index.empty.title')}
            onClick={() =>
              navigate('/settings', { state: { targetedTab: 'link-index' } })
            }
            buttonWidth="16rem"
          />
        </Flex>
      )}
    </DashboardWidget>
  );
};
